import React, { useEffect, useContext } from "react";
import { useParams } from "react-router-dom";

import ArticleListing from "../../Components/Articles/ArticleListing";
import LegacyArticleListing from "../../Components/Legacy/LegacyArticleListing";
import { KBContext } from "../../Context/index";
import { useCategoryBySlug } from "../../hooks/apis/useCategory";
import { useCategoryArticles } from "../../hooks/apis/useCategoryArticles";
import useNavigateWithSearch from "../../Context/KBContext/hooks/useNavigateWithSearch";
import { handleGainSightEventForPageNotFound } from "../../gainSightIntegration";
import { isNewUIEnabled } from "../../utils";

export default function ArticleList() {

  const { data, availableFeatures } = useContext(KBContext);
  const navigate = useNavigateWithSearch();
  const isNewUI = isNewUIEnabled(availableFeatures);

  const { categorySlug } = useParams();
  const { data: selectedCategory, error } = useCategoryBySlug({ categorySlug });
  const { data: articleData, isLoading } = useCategoryArticles({ categorySlug });

  const handleArticleClick = (article) => {
    navigate(`/${selectedCategory.slug}/${article.slug}`);
  };

  useEffect(() => {
    if( !error ){
      return;
    }
    if( error?.response?.status === 404 ){
      handleGainSightEventForPageNotFound(window.location.href);
    }
    navigate("/not-found");
  }, [ error ]);

  const ListingComponent = isNewUI ? ArticleListing : LegacyArticleListing;

  return (
    <ListingComponent
      kbdata={data}
      selectedCategory={selectedCategory}
      articles={articleData ?? []}
      isLoading={isLoading}
      handleArticleClick={handleArticleClick}
    />
  );
}
